module.exports = __webpack_public_path__ + "img/new-logo (1).199f73d7.png";